//Action Types
export const UPDATE_OFFICE_KEY = 'UPDATE_OFFICE_KEY';
import { OFFICE_DATA } from '../common/constants/contactInfoData';

export const updateOfficeKey: Function = (office: string) => ({
    type: UPDATE_OFFICE_KEY,
    payload: OFFICE_DATA[office],
});
